import Dashboard from "../pages/Dashboard";
import DefaultCrudRouter from "../routes/DefaultCrudRouter";
import ContentTickets from "../pages/Content/Tickets";
import ContentTablet from "../pages/Content/Tablet";
import ContentPages from "../pages/Content/Pages";
import ContentWebSales from "../pages/Content/WebSales";
import ContentJackpot from "../pages/Content/Jackpot";
import CampaignList from "../pages/Campaign/CampaignList";
import CampaignForm from "../pages/Campaign/CampaignForm";
import CampaignView from "../pages/Campaign/CampaignView";
import EventRouter from "../routes/EventRouter";
import EventList from "../pages/Events/EventList";
import EventForm from "../pages/Events/EventForm";
import EventSellers from "../pages/Events/EventSellers";
import EventManageSellers from "../components/forms/event/Sellers";
import EventWinners from "../pages/Events/EventWinners";
import EventSummary from "../pages/Events/EventSummary";
import EventDevices from "../pages/Events/EventDevices";
import EventMessages from "../pages/Events/EventMessages";
import EventTickets from "../pages/Events/EventTickets";
import EventCashDrops from "../pages/Events/EventCashDrops";
import EventVoids from "../pages/Events/EventVoids";
import EventTabletImport from "../pages/Events/EventTabletImport";
import HelpJackpot from "../pages/Help/HelpJackpot";
import HelpApp from "../pages/Help/HelpApp";
import HelpLinks from "../pages/Help/HelpLinks";
import HelpCreditCards from "../pages/Help/HelpCreditCards";
import HelpXmlScoreboard from "../pages/Help/HelpXmlScoreboard";
import HelpXmlWinners from "../pages/Help/HelpXmlWinners";
import HelpXmlEvent from "../pages/Help/HelpXmlEvent";
import SellerList from "../pages/Sellers/SellerList";
import SellerProfile from "../pages/Sellers/SellerProfile";
import Devices from "../pages/Devices/DeviceList";
import DeviceProfile from "../pages/Devices/DeviceProfile";
import NonProfitList from "../pages/NonProfit/NonProfitList";
import NonProfitForm from "../pages/NonProfit/NonProfitForm";
import BeneficiaryList from "../pages/Beneficiary/BeneficiaryList";
import BeneficiaryForm from "../pages/Beneficiary/BeneficiaryForm";
import AccountList from "../pages/Accounts/AccountList";
import Account from "../pages/Accounts/AccountProfile";
import Report from "../pages/Reports/Report";
import SettingsSystem from "../pages/Admin/SettingsSystem";
import SettingsGeofence from "../components/settings/GeofenceTab";
import SettingsBitmask from "../components/settings/SettingsBitmask";
import EventContributions from "../pages/Events/EventContributions";
import DefaultPageRouter from "../routes/DefaultPageRouter";
import NestedPageRouter from "../routes/NestedPageRouter";
import AdminTheme from "../pages/Admin/AdminTheme";
import SignatureList from "../pages/Signature/SignatureList";
import SignatureView from "../pages/Signature/SignatureView";
import SmsList from "../pages/Sms/SmsList";
import SmsForm from "../pages/Sms/SmsForm";
import SocialAccounts from "../pages/Social/SocialAccounts";
import SocialCannedList from "../pages/Social/SocialCannedList";
import SocialCannedForm from "../pages/Social/SocialCannedForm";
import SocialPostsForm from "../pages/Social/SocialPostsForm";
import SocialPostsList from "../pages/Social/SocialPostsList";
import Subscription from "../pages/Subscriptions/Subscription";
import SettingsPrinters from "../pages/Admin/SettingsPrinters";
import EventReprint from "../pages/Events/EventReprint";

export const accountRoutes = [
  {
    path: "/accounts",
    name: "listAccount",
    title: "List Accounts",
    exact: true,
    component: AccountList
  },
  {
    path: "/accounts/create",
    name: "createAccount",
    title: "Create Account",
    exact: true,
    component: Account
  },
  {
    path: "/accounts/:id/edit",
    name: "accountForm",
    title: "Account",
    component: Account
  }
];
export const campaignRoutes = [
  {
    path: "/campaigns",
    name: "campaigns",
    title: "List Campaigns",
    exact: true,
    component: CampaignList
  },
  {
    path: "/campaigns/create",
    name: "campaignForm",
    title: "Campaign Form",
    exact: true,
    component: CampaignForm
  },
  {
    path: "/campaigns/:id/summary",
    name: "campaignDetails",
    title: "Campaign Details",
    exact: true,
    component: CampaignView
  },
  {
    path: "/campaigns/:id/edit",
    name: "campaignForm",
    title: "Campaign Form",
    exact: true,
    component: CampaignForm
  }
];
export const contentManagerRoutes = [
  {
    path: "/content-manager/tickets",
    name: "contentManagerTickets",
    title: "Tickets",
    component: ContentTickets,
    routes: []
  },
  {
    path: "/content-manager/tablet",
    name: "contentManagerTablet",
    title: "Tablet",
    component: ContentTablet,
    routes: []
  },
  {
    path: "/content-manager/web-sales",
    name: "contentManagerWebSales",
    title: "E-commerce",
    component: ContentWebSales,
    routes: []
  },
  {
    path: "/content-manager/jackpot/:method?",
    name: "contentManagerJackpot",
    title: "Jackpot",
    component: ContentJackpot,
    routes: []
  },
  {
    path: "/content-manager/pages/:method",
    name: "contentManagerPages",
    title: "Pages",
    component: ContentPages,
    subNav: true,
    routes: [
      {
        path: "/content-manager/pages/webhowitworkstext",
        name: "webhowitworkstext",
        title: "How It Works"
      },
      {
        path: "/content-manager/pages/weblocationtroubleshootingtext",
        name: "weblocationtroubleshootingtext",
        title: "Location Troubleshooting"
      },
      {
        path: "/content-manager/pages/webaboutustext",
        name: "webaboutustext",
        title: "About Us"
      },
      {
        path: "/content-manager/pages/webclaimformstext",
        name: "webclaimformstext",
        title: "Claim Forms"
      },
      {
        path: "/content-manager/pages/webfaqtext",
        name: "webfaqtext",
        title: "F.A.Q."
      },
      {
        path: "/content-manager/pages/webprivacytext",
        name: "webprivacytext",
        title: "Privacy"
      },
      {
        path: "/content-manager/pages/webproceedstext",
        name: "webproceedstext",
        title: "Proceeds"
      },
      {
        path: "/content-manager/pages/webrulestext",
        name: "webrulestext",
        title: "Rules"
      },
      {
        path: "/content-manager/pages/webtermstext",
        name: "webtermstext",
        title: "Terms"
      }

      // {
      //   path: "/content-manager/pages/webfootertext",
      //   name: "webfootertext",
      //   title: "Footer text"
      // }
    ]
  }
];
export const deviceRoutes = [
  {
    path: "/devices",
    name: "listDevice",
    title: "List Devices",
    exact: true,
    component: Devices
  },
  {
    path: "/devices/create",
    name: "createDevice",
    title: "Create Device",
    exact: true,
    component: DeviceProfile
  },
  {
    path: "/devices/:id/edit",
    name: "device",
    title: "Device",
    component: DeviceProfile
  }
];
export const eventRoutes = [
  {
    path: "/events",
    name: "eventList",
    title: "Event List",
    exact: true,
    component: EventList
  },
  {
    path: "/events/create",
    name: "eventCreate",
    title: "Create Event",
    exact: true,
    component: EventForm
  },
  {
    path: "/events/:id/edit",
    name: "eventEdit",
    title: "Edit Event",
    exact: true,
    component: EventForm
  },
  {
    path: "/events/:id/summary",
    name: "eventId",
    title: "Summary",
    exact: true,
    component: EventSummary
  },
  {
    path: "/events/:id/sellers",
    name: "eventSellers",
    title: "Sellers",
    exact: true,
    component: EventSellers,
    routes: []
  },
  {
    path: "/events/:id/sellers/manage",
    name: "eventManageSellers",
    title: "Manage Sellers",
    exact: true,
    component: EventManageSellers,
    routes: []
  },
  {
    path: "/events/:id/devices",
    name: "eventDevices",
    title: "Devices",
    component: EventDevices,
    routes: []
  },
  {
    path: "/events/:id/messages",
    name: "eventMessages",
    title: "Messages",
    component: EventMessages,
    routes: []
  },
  {
    path: "/events/:id/import",
    name: "eventTabletImport",
    title: "Tablet Import",
    component: EventTabletImport,
    routes: []
  },
  {
    path: "/events/:id/winners",
    name: "eventWinners",
    title: "Winners",
    component: EventWinners,
    routes: []
  },
  {
    path: "/events/:id/payments",
    name: "eventTickets",
    title: "Payments",
    component: EventTickets,
    routes: []
  },
  {
    path: "/events/:id/cashdrops",
    name: "eventCashDrops",
    title: "Cash Drops",
    private: true,
    component: EventCashDrops,
    routes: []
  },
  {
    path: "/events/:id/voids",
    name: "eventVoids",
    title: "Voids",
    component: EventVoids,
    routes: []
  },
  {
    path: "/events/:id/contributions",
    name: "eventContributions",
    title: "Contributions",
    component: EventContributions,
    routes: []
  },
  {
    path: "/events/:id/reprint",
    name: "eventReprint",
    title: "Reprint",
    private: true,
    component: EventReprint,
    routes: []
  }
];
export const helpRoutes = [
  {
    path: "/help/application",
    name: "helpApplication",
    title: "Android Application",
    component: HelpApp,
    routes: []
  },
  {
    path: "/help/jackpot",
    name: "helpJackpot",
    title: "Jackpot Display",
    component: HelpJackpot,
    routes: []
  },
  {
    path: "/help/xml/:action?",
    name: "helpXml",
    title: "XML Feeds",
    component: DefaultPageRouter,
    subNav: true,
    routes: [
      {
        path: "/help/xml/scoreboard",
        name: "helpXmlScoreboard",
        title: "Scoreboard",
        component: HelpXmlScoreboard
      },
      {
        path: "/help/xml/winners",
        name: "helpXmlWinners",
        title: "Winners",
        component: HelpXmlWinners
      },
      {
        path: "/help/xml/event",
        name: "helpXmlEvent",
        title: "Event Details",
        component: HelpXmlEvent
      }
    ]
  },
  {
    path: "/help/links",
    name: "helpLinks",
    title: "Links",
    component: HelpLinks,
    routes: []
  },
  {
    path: "/help/credit-cards",
    name: "helpCreditCards",
    title: "Credit Cards",
    component: HelpCreditCards,
    routes: []
  }
];
export const nonProfitRoutes = [
  {
    path: "/non-profits",
    name: "listNonProfit",
    title: "List Non-Profits",
    exact: true,
    component: NonProfitList
  },
  {
    path: "/non-profits/create",
    name: "createNonProfit",
    title: "Create Non-Profit",
    exact: true,
    component: NonProfitForm
  },
  {
    path: "/non-profits/:id/edit",
    name: "NonProfit",
    title: "Non-Profit",
    component: NonProfitForm
  }
];
export const beneficiaryRoutes = [
  {
    path: "/beneficiaries",
    name: "listBeneficiary",
    title: "List Beneficiary",
    exact: true,
    component: BeneficiaryList
  },
  {
    path: "/beneficiaries/create",
    name: "createBeneficiary",
    title: "Create Beneficiary",
    exact: true,
    component: BeneficiaryForm
  },
  {
    path: "/beneficiaries/:id/edit",
    name: "beneficiary",
    title: "Beneficiary",
    component: BeneficiaryForm
  }
];
export const sellerRoutes = [
  {
    path: "/sellers",
    name: "listSeller",
    title: "List Sellers",
    exact: true,
    component: SellerList
  },
  {
    path: "/sellers/create",
    name: "createSeller",
    title: "Create Seller",
    exact: true,
    component: SellerProfile
  },
  {
    path: "/sellers/:id/edit",
    name: "seller",
    title: "Edit Seller",
    exact: true,
    component: SellerProfile
  }
];
export const smsRoutes = [
  {
    path: "/sms",
    name: "smsList",
    title: "List Text Messages",
    exact: true,
    component: SmsList
  },
  {
    path: "/sms/create",
    name: "createSms",
    title: "Create Text Message",
    exact: true,
    component: SmsForm
  }
];
export const settingRoutes = [
  {
    path: "/settings/system",
    name: "settingsSystem",
    title: "System",
    component: SettingsSystem,
    routes: []
  },
  {
    path: "/settings/tablet",
    name: "settingsTablet",
    title: "Tablet",
    component: SettingsSystem,
    routes: []
  },
  {
    path: "/settings/web",
    name: "settingsWeb",
    title: "Web",
    component: SettingsSystem,
    routes: []
  },
  // {
  //   path: "/settings/venue",
  //   name: "settingsVenue",
  //   title: "Venue",
  //   component: SettingsVenue,
  //   routes: []
  // },
  // {
  //   path: "/settings/location",
  //   name: "settingsLocation",
  //   title: "Location",
  //   component: SettingsLocation,
  //   routes: []
  // },
  // {
  //   path: "/settings/geofence",
  //   name: "settingsGeofence",
  //   title: "Geofencing",
  //   component: SettingsGeofence,
  //   routes: []
  // },
  {
    path: "/settings/bitmask",
    name: "settingsBitmask",
    title: "Geofence - Bitmask",
    component: SettingsBitmask,
    routes: []
  },
  {
    path: "/settings/printers",
    name: "settingsPrinters",
    title: "Drum Printers",
    component: SettingsPrinters,
    routes: []
  },
  // {
  //   path: "/settings/log",
  //   name: "settingsLog",
  //   title: "Raw Server Log",
  //   component: Placeholder,
  //   routes: []
  // },
  {
    path: "/settings/theme",
    name: "settingsTheme",
    title: "Theme",
    component: AdminTheme,
    routes: []
  }
];
export const signatureRoutes = [
  {
    path: "/software-signature",
    name: "signature",
    title: "Software Signature",
    exact: true,
    component: SignatureList
  },
  {
    path: "/software-signature/:id",
    name: "signatureView",
    title: "Software Signature Report",
    exact: true,
    component: SignatureView
  }
];
export const socialRoutes = [
  {
    path: "/social",
    name: "social",
    title: "Accounts",
    private: false,
    exact: true,
    component: SocialAccounts
  },
  {
    path: "/social/accounts",
    name: "socialAccounts",
    title: "Accounts",
    exact: true,
    component: SocialAccounts
  },
  {
    path: "/social/posts",
    name: "createPosts",
    title: "Posts",
    exact: true,
    component: SocialPostsList
  },
  {
    path: "/social/posts/create",
    name: "createPosts",
    title: "Create Post",
    private: false,
    exact: true,
    component: SocialPostsForm
  },
  {
    path: "/social/posts/:id/edit",
    name: "device",
    title: "Posts",
    private: false,
    exact: true,
    component: SocialPostsForm
  },
  {
    path: "/social/canned",
    name: "createCanned",
    title: "Canned Messages",
    exact: true,
    component: SocialCannedList
  },
  {
    path: "/social/canned/create",
    name: "createCanned",
    title: "Create Canned Message",
    private: false,
    exact: true,
    component: SocialCannedForm
  },
  {
    path: "/social/canned/:id/edit",
    name: "device",
    title: "Edit Canned Message",
    private: false,
    exact: true,
    component: SocialCannedForm
  }
]
export const privateRoutes = [
  {
    path: "/",
    name: "home",
    title: "Dashboard",
    exact: true,
    component: Dashboard
  },
  {
    path: "/campaigns/:id?/:action?/:method?",
    name: "campaign",
    title: "Campaigns",
    exact: true,
    component: DefaultCrudRouter,
    routes: campaignRoutes,
    subNav: false
  },
  {
    path: "/events/:id?/:action?/:method?",
    name: "event",
    title: "Events",
    exact: true,
    component: EventRouter,
    routes: eventRoutes,
    subNav: false
  },
  {
    path: "/sellers/:id?/:action?/:method?",
    name: "sellers",
    title: "Sellers",
    exact: true,
    component: DefaultCrudRouter,
    routes: sellerRoutes,
    subNav: false
  },
  {
    path: "/devices/:id?/:action?/:method?",
    name: "devices",
    title: "Devices",
    exact: true,
    component: DefaultCrudRouter,
    routes: deviceRoutes,
    subNav: false
  },
  {
    path: "/non-profits/:id?/:action?/:method?",
    name: "non-profits",
    title: "Non-Profits",
    exact: true,
    component: DefaultCrudRouter,
    routes: nonProfitRoutes,
    subNav: false
  },
  {
    path: "/beneficiaries/:id?/:action?/:method?",
    name: "beneficiaries",
    title: "Beneficiaries",
    exact: true,
    component: DefaultCrudRouter,
    routes: beneficiaryRoutes,
    subNav: false
  },
  {
    path: "/accounts/:id?/:action?/:method?",
    name: "accounts",
    title: "Accounts",
    exact: true,
    component: DefaultCrudRouter,
    routes: accountRoutes,
    subNav: false
  },
  {
    path: "/reports",
    name: "reports",
    title: "Reports",
    component: Report
  },
  {
    path: "/subscriptions",
    name: "subscriptions",
    title: "Subscriptions",
    component: Subscription
  },
  // {
  //   path: "/sms/:id?/:action?/:method?",
  //   name: "sms",
  //   title: "Text Messaging",
  //   exact: true,
  //   component: DefaultCrudRouter,
  //   routes: smsRoutes,
  //   subNav: false
  // },
  {
    path: "/social/:id?/:action?/:method?",
    name: "social",
    title: "Social Media",
    exact: true,
    component: DefaultCrudRouter,
    routes: socialRoutes,
    subNav: true
  },
  {
    path: "/content-manager/:action?/:method?",
    name: "contentManager",
    title: "Content Manager",
    exact: true,
    component: NestedPageRouter,
    routes: contentManagerRoutes,
    subNav: true
  },
  {
    path: "/help/:action?/:method?",
    name: "help",
    title: "Help",
    exact: true,
    component: DefaultPageRouter,
    routes: helpRoutes,
    subNav: true
  },
  {
    path: "/settings/:id?/:action?/:method?",
    name: "settings",
    title: "Settings",
    exact: true,
    component: DefaultCrudRouter,
    routes: settingRoutes,
    subNav: true
  },
  {
    path: "/software-signature/:id?/:action?/:method?",
    name: "softwareSignature",
    title: "Software Signature",
    exact: true,
    component: DefaultCrudRouter,
    routes: signatureRoutes,
    subNav: false
  }
];
